import config from './config';

export interface IdentityConfig {
  authority: string;
  client_id: string;
  redirect_uri: string;
  loadUserInfo: boolean;
  post_logout_redirect_uri: string;
  response_type: string;
  scope: string;
  revokeAccessTokenOnSignout: boolean;
}

export const IDENTITY_CONFIG: IdentityConfig = {
  authority: config.authAuthorityLegacy, //(string): The URL of the OIDC provider.
  client_id: 'viewer.scribonline.com/external.local', //(string): Your client application's identifier as registered with the OIDC provider.
  redirect_uri: `${config.hostUrl}/signin-callback.html`, //The URI of your client application to receive a response from the OIDC provider.
  loadUserInfo: false, //(boolean, default: true): Flag to control if additional identity data is loaded from the user info endpoint in order to populate the user's profile.
  post_logout_redirect_uri: `${config.hostUrl}/external`, // (string): The OIDC post-logout redirect URI.
  response_type: 'code',
  scope: 'openid profile email api',
  revokeAccessTokenOnSignout: true
};

export const IDENTITY_CONFIG_MODERN: IdentityConfig = {
  authority: config.authAuthorityModern, //(string): The URL of the OIDC provider.
  client_id: 'viewer.scribonline.com/external.local.modern', //(string): Your client application's identifier as registered with the OIDC provider.
  redirect_uri: `${config.hostUrl}/signin-callback.html`, //The URI of your client application to receive a response from the OIDC provider.
  loadUserInfo: false, //(boolean, default: true): Flag to control if additional identity data is loaded from the user info endpoint in order to populate the user's profile.
  post_logout_redirect_uri: `${config.hostUrl}/external?newchive=true`, // (string): The OIDC post-logout redirect URI.
  response_type: 'code',
  scope: 'openid profile email api',
  revokeAccessTokenOnSignout: true
};
